import { diatype } from '@ag1/fonts';
import { vars, zIndex } from '@ag1/ui/theme';
import { StylesConfig } from 'react-select';

const { colors, spacing } = vars;

export function style(hasError: boolean, dense?: boolean, label?: boolean): StylesConfig {
  return {
    menu: (baseStyles) => ({
      ...baseStyles,
      boxShadow: '0px 4px 8px rgb(107 114 128 / 16%)',
      borderRadius: '6px',
      overflow: 'hidden',
      marginTop: spacing.smd
    }),
    menuPortal: (baseStyles) => ({
      ...baseStyles,
      zIndex: zIndex.dropdown
    }),
    menuList: (baseStyles) => ({
      ...baseStyles,
      paddingBottom: spacing.sm,
      paddingTop: spacing.xs
    }),
    control: (baseStyles, state) => ({
      ...baseStyles,
      '-webkit-appearance': 'none',
      boxShadow: 'none',
      fontFamily: diatype.style.fontFamily,
      borderColor: hasError
        ? colors.input.border.error
        : state.isFocused
        ? colors.input.border.focus
        : colors.input.border.default,
      fontWeight: 400,
      backgroundColor: 'inherit',
      borderRadius: '6px',
      minHeight: '44px',
      cursor: 'pointer',
      '&:hover': {
        borderColor: hasError ? colors.input.border.error : colors.input.border.focus
      }
    }),
    valueContainer: (baseStyles) => ({
      ...baseStyles,
      padding: dense
        ? `${spacing.sm} ${spacing.md}`
        : label
        ? `${spacing.lg} ${spacing.md} ${spacing.xs}`
        : `${spacing.smd} ${spacing.md}`,
      margin: 0
    }),
    singleValue: (baseStyles) => ({
      ...baseStyles,
      color: colors.input.text.value,
      margin: 0
    }),
    placeholder: (baseStyles) => ({
      ...baseStyles,
      color: colors.input.text.placeholder,
      margin: '0'
    }),
    input: (baseStyles) => ({
      ...baseStyles,
      marginLeft: 0,
      marginTop: 0,
      margin: 0,
      padding: 0,
      lineHeight: '24px'
    }),
    option: (baseStyles, { isDisabled, isSelected, isFocused }) => ({
      ...baseStyles,
      fontFamily: diatype.style.fontFamily,
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '24px',
      color: isDisabled ? colors.input.text.disabled : colors.input.text.value,
      padding: '12px 16px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: isDisabled
        ? 'inherit'
        : isSelected
        ? '#F7F8F7'
        : isFocused
        ? '#F7F8F7'
        : 'inherit',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      '&:hover': {
        backgroundColor: !isDisabled ? '#F7F8F7' : 'inherit' // need to hardcode due to react-select issues
      },
      '&:focus': {
        backgroundColor: !isDisabled ? '#F7F8F7' : 'inherit' // need to hardcode due to react-select issues
      },
      '&:active': {
        backgroundColor: !isDisabled ? '#F7F8F7' : 'inherit'
      },
      '&.select__option': {
        padding: 0
      }
    }),
    indicatorSeparator: () => ({
      display: 'none',
      padding: '8px 14px 8px 8px'
    }),
    indicatorsContainer: (baseStyles) => ({
      ...baseStyles,
      paddingRight: '8px'
    }),
    dropdownIndicator: (baseStyles) => ({
      ...baseStyles,
      padding: 0,
      cursor: 'pointer',
      fontSize: '24px',
      color: colors.icon.default,
      minWidth: '24px',
      minHeight: 'auto'
    })
  };
}
